import { inject, ComponentAttached } from "aurelia-framework";
import { HttpClientService } from "../../services/http-client-service";

@inject(HttpClientService)
export class Log implements ComponentAttached {
  log: string;

  constructor(private httpClientService: HttpClientService) {}

  activate(): Promise<void> {
    return this.httpClientService
      .get()
      .get("admin/log")
      .then((r) => (this.log = r.content))
      .catch((e) => (this.log = "Error loading log."));
  }

  attached() {}
}
